
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta } from "/src/pages/index.vue?macro=true";
import { default as loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta } from "/src/pages/auth/login.vue?macro=true";
import { default as indexn2s7p5m3f2IvTsOutjwrZistLUury3_45ZZ55qWn9C9MkMeta } from "/src/pages/admin/index.vue?macro=true";
import { default as loginAoIb1_FkjVdFtHlWoAViXkenWP1KfferWGxH9k8NuSgMeta } from "/src/pages/admin/login.vue?macro=true";
import { default as configsMvmElh54yPBCoQiENxrib7cU1hoVF3FA_45nElPjk0DUMeta } from "/src/pages/admin/config.vue?macro=true";
import { default as exportsTdJLufKgpMpwsPAR444509miCcqzOv4pzxBttuAcWkAMeta } from "/src/pages/admin/exports.vue?macro=true";
import { default as promptshWer2Ui7h0hSkUNfWWtRgTrzvtYN816ntvNnDLPYbTUMeta } from "/src/pages/admin/prompts.vue?macro=true";
import { default as registerp__45WqYjweBSM9_45Ke3Et_KHOD3NRIZ0TmynBsXh8jze4Meta } from "/src/pages/auth/register.vue?macro=true";
import { default as channelsx3KUtBe9UmBGo_GP7iDyiiF3uuKj9siNq9PwX4uxovsMeta } from "/src/pages/admin/channels.vue?macro=true";
import { default as settingsNkVVVFb4JRn9IvLwMLageK_45K7YkmGZaAUiRTei3q4g0Meta } from "/src/pages/admin/settings.vue?macro=true";
import { default as trainingKyqk7BCuD4jtTziJ4JMQi5PFaXNLCQ1dNJk_oZyYjBEMeta } from "/src/pages/admin/training.vue?macro=true";
import { default as emailCnCsGyrm9FfyJKialljMqLF2Qx7KtC142eWyH1bwH_AMeta } from "/src/pages/settings/email.vue?macro=true";
import { default as _91id_93JBNyt2YVjN9skiFkzd6M2OQJNHF7Lp_45Y6885gqkiOQEMeta } from "/src/pages/admin/sales/[id].vue?macro=true";
import { default as index3gAM9aa8R9hs9BWAhjRrOL_45mgN1vNuu6QknfDos3yosMeta } from "/src/pages/admin/sales/index.vue?macro=true";
import { default as indexCWiabXyGEggpFKbCMMhikYaV77ezKOR7TXc1YKElcXsMeta } from "/src/pages/admin/emails/index.vue?macro=true";
import { default as indexahbK8T02ODhOek4OKPs3_dW_JYF6hWDIhH_Q66bdofcMeta } from "/src/pages/admin/orders/index.vue?macro=true";
import { default as reset_45passwordgUEPokzjVolIeJSfbkYFVHxrrCI9r22vS4I0_45OIGWeMMeta } from "/src/pages/auth/reset-password.vue?macro=true";
import { default as oauth_45successSJsrxqW7g_45INBNmAw63qzwOxu3eO5VWZm8IiVbNxdAUMeta } from "/src/pages/email/oauth-success.vue?macro=true";
import { default as _91id_93AzGiGTtNARe_45iNJ5JSvpg_45vI75jjYaWZCeJf7ON5nHEMeta } from "/src/pages/admin/customers/[id].vue?macro=true";
import { default as forgot_45passwordFpwAwxBggxx3KkxDmE50wQmdHR5V1iatb2SegeEJCN0Meta } from "/src/pages/auth/forgot-password.vue?macro=true";
import { default as indexfYheWFxU_RkH2m7QYfxwjZKjiW6VlBN_45eXdUgr86bZoMeta } from "/src/pages/admin/customers/index.vue?macro=true";
import { default as _91emailId_93Pom7i3ZDjDbYSE2rIu5WGe8_Svsmp6mFS4_45GUkPQRw0Meta } from "/src/pages/admin/emails/[emailId].vue?macro=true";
import { default as _91orderId_93l0n9GvF64pv3ekD68vL8FgT2DiKRSs0qh1v0msc1pQoMeta } from "/src/pages/admin/orders/[orderId].vue?macro=true";
import { default as _91requestId_937Iay6MZaR3PCgRL0AcGMRpYlME25Z30DBDoI2WiHLzAMeta } from "/src/pages/customer/requests/[requestId].vue?macro=true";
import { default as _91emailId_93tC0vFKa1FkN75qJ9ORqoTyDqh9HhO3KhEb_45nBl6oG1AMeta } from "/src/pages/admin/customers/emails/[emailId].vue?macro=true";
export default [
  {
    name: "index___fr-FR",
    path: "/",
    meta: indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta || {},
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "index___en-GB",
    path: "/en-GB",
    meta: indexD8Kf5nPoGkO_45mPRcy0kXxYdHgQUU8jSfv0icJqY11_45oMeta || {},
    component: () => import("/src/pages/index.vue")
  },
  {
    name: "auth-login___fr-FR",
    path: "/auth/login",
    meta: loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta || {},
    component: () => import("/src/pages/auth/login.vue")
  },
  {
    name: "auth-login___en-GB",
    path: "/en-GB/auth/login",
    meta: loginKh1lzCxnBtobxkuv2GDj3oee1aTskBX3mKL0STWmGEcMeta || {},
    component: () => import("/src/pages/auth/login.vue")
  },
  {
    name: "admin___fr-FR",
    path: "/admin",
    meta: indexn2s7p5m3f2IvTsOutjwrZistLUury3_45ZZ55qWn9C9MkMeta || {},
    component: () => import("/src/pages/admin/index.vue")
  },
  {
    name: "admin___en-GB",
    path: "/en-GB/admin",
    meta: indexn2s7p5m3f2IvTsOutjwrZistLUury3_45ZZ55qWn9C9MkMeta || {},
    component: () => import("/src/pages/admin/index.vue")
  },
  {
    name: "admin-login___fr-FR",
    path: "/admin/login",
    meta: loginAoIb1_FkjVdFtHlWoAViXkenWP1KfferWGxH9k8NuSgMeta || {},
    component: () => import("/src/pages/admin/login.vue")
  },
  {
    name: "admin-login___en-GB",
    path: "/en-GB/admin/login",
    meta: loginAoIb1_FkjVdFtHlWoAViXkenWP1KfferWGxH9k8NuSgMeta || {},
    component: () => import("/src/pages/admin/login.vue")
  },
  {
    name: "admin-config___fr-FR",
    path: "/admin/config",
    meta: configsMvmElh54yPBCoQiENxrib7cU1hoVF3FA_45nElPjk0DUMeta || {},
    component: () => import("/src/pages/admin/config.vue")
  },
  {
    name: "admin-config___en-GB",
    path: "/en-GB/admin/config",
    meta: configsMvmElh54yPBCoQiENxrib7cU1hoVF3FA_45nElPjk0DUMeta || {},
    component: () => import("/src/pages/admin/config.vue")
  },
  {
    name: "admin-exports___fr-FR",
    path: "/admin/exports",
    meta: exportsTdJLufKgpMpwsPAR444509miCcqzOv4pzxBttuAcWkAMeta || {},
    component: () => import("/src/pages/admin/exports.vue")
  },
  {
    name: "admin-exports___en-GB",
    path: "/en-GB/admin/exports",
    meta: exportsTdJLufKgpMpwsPAR444509miCcqzOv4pzxBttuAcWkAMeta || {},
    component: () => import("/src/pages/admin/exports.vue")
  },
  {
    name: "admin-prompts___fr-FR",
    path: "/admin/prompts",
    meta: promptshWer2Ui7h0hSkUNfWWtRgTrzvtYN816ntvNnDLPYbTUMeta || {},
    component: () => import("/src/pages/admin/prompts.vue")
  },
  {
    name: "admin-prompts___en-GB",
    path: "/en-GB/admin/prompts",
    meta: promptshWer2Ui7h0hSkUNfWWtRgTrzvtYN816ntvNnDLPYbTUMeta || {},
    component: () => import("/src/pages/admin/prompts.vue")
  },
  {
    name: "auth-register___fr-FR",
    path: "/auth/register",
    meta: registerp__45WqYjweBSM9_45Ke3Et_KHOD3NRIZ0TmynBsXh8jze4Meta || {},
    component: () => import("/src/pages/auth/register.vue")
  },
  {
    name: "auth-register___en-GB",
    path: "/en-GB/auth/register",
    meta: registerp__45WqYjweBSM9_45Ke3Et_KHOD3NRIZ0TmynBsXh8jze4Meta || {},
    component: () => import("/src/pages/auth/register.vue")
  },
  {
    name: "admin-channels___fr-FR",
    path: "/admin/channels",
    meta: channelsx3KUtBe9UmBGo_GP7iDyiiF3uuKj9siNq9PwX4uxovsMeta || {},
    component: () => import("/src/pages/admin/channels.vue")
  },
  {
    name: "admin-channels___en-GB",
    path: "/en-GB/admin/channels",
    meta: channelsx3KUtBe9UmBGo_GP7iDyiiF3uuKj9siNq9PwX4uxovsMeta || {},
    component: () => import("/src/pages/admin/channels.vue")
  },
  {
    name: "admin-settings___fr-FR",
    path: "/admin/settings",
    meta: settingsNkVVVFb4JRn9IvLwMLageK_45K7YkmGZaAUiRTei3q4g0Meta || {},
    component: () => import("/src/pages/admin/settings.vue")
  },
  {
    name: "admin-settings___en-GB",
    path: "/en-GB/admin/settings",
    meta: settingsNkVVVFb4JRn9IvLwMLageK_45K7YkmGZaAUiRTei3q4g0Meta || {},
    component: () => import("/src/pages/admin/settings.vue")
  },
  {
    name: "admin-training___fr-FR",
    path: "/admin/training",
    meta: trainingKyqk7BCuD4jtTziJ4JMQi5PFaXNLCQ1dNJk_oZyYjBEMeta || {},
    component: () => import("/src/pages/admin/training.vue")
  },
  {
    name: "admin-training___en-GB",
    path: "/en-GB/admin/training",
    meta: trainingKyqk7BCuD4jtTziJ4JMQi5PFaXNLCQ1dNJk_oZyYjBEMeta || {},
    component: () => import("/src/pages/admin/training.vue")
  },
  {
    name: "settings-email___fr-FR",
    path: "/settings/email",
    meta: emailCnCsGyrm9FfyJKialljMqLF2Qx7KtC142eWyH1bwH_AMeta || {},
    component: () => import("/src/pages/settings/email.vue")
  },
  {
    name: "settings-email___en-GB",
    path: "/en-GB/settings/email",
    meta: emailCnCsGyrm9FfyJKialljMqLF2Qx7KtC142eWyH1bwH_AMeta || {},
    component: () => import("/src/pages/settings/email.vue")
  },
  {
    name: "admin-sales-id___fr-FR",
    path: "/admin/sales/:id()",
    meta: _91id_93JBNyt2YVjN9skiFkzd6M2OQJNHF7Lp_45Y6885gqkiOQEMeta || {},
    component: () => import("/src/pages/admin/sales/[id].vue")
  },
  {
    name: "admin-sales-id___en-GB",
    path: "/en-GB/admin/sales/:id()",
    meta: _91id_93JBNyt2YVjN9skiFkzd6M2OQJNHF7Lp_45Y6885gqkiOQEMeta || {},
    component: () => import("/src/pages/admin/sales/[id].vue")
  },
  {
    name: "admin-sales___fr-FR",
    path: "/admin/sales",
    meta: index3gAM9aa8R9hs9BWAhjRrOL_45mgN1vNuu6QknfDos3yosMeta || {},
    component: () => import("/src/pages/admin/sales/index.vue")
  },
  {
    name: "admin-sales___en-GB",
    path: "/en-GB/admin/sales",
    meta: index3gAM9aa8R9hs9BWAhjRrOL_45mgN1vNuu6QknfDos3yosMeta || {},
    component: () => import("/src/pages/admin/sales/index.vue")
  },
  {
    name: "admin-emails___fr-FR",
    path: "/admin/emails",
    meta: indexCWiabXyGEggpFKbCMMhikYaV77ezKOR7TXc1YKElcXsMeta || {},
    component: () => import("/src/pages/admin/emails/index.vue")
  },
  {
    name: "admin-emails___en-GB",
    path: "/en-GB/admin/emails",
    meta: indexCWiabXyGEggpFKbCMMhikYaV77ezKOR7TXc1YKElcXsMeta || {},
    component: () => import("/src/pages/admin/emails/index.vue")
  },
  {
    name: "admin-orders___fr-FR",
    path: "/admin/orders",
    meta: indexahbK8T02ODhOek4OKPs3_dW_JYF6hWDIhH_Q66bdofcMeta || {},
    component: () => import("/src/pages/admin/orders/index.vue")
  },
  {
    name: "admin-orders___en-GB",
    path: "/en-GB/admin/orders",
    meta: indexahbK8T02ODhOek4OKPs3_dW_JYF6hWDIhH_Q66bdofcMeta || {},
    component: () => import("/src/pages/admin/orders/index.vue")
  },
  {
    name: "auth-reset-password___fr-FR",
    path: "/auth/reset-password",
    meta: reset_45passwordgUEPokzjVolIeJSfbkYFVHxrrCI9r22vS4I0_45OIGWeMMeta || {},
    component: () => import("/src/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___en-GB",
    path: "/en-GB/auth/reset-password",
    meta: reset_45passwordgUEPokzjVolIeJSfbkYFVHxrrCI9r22vS4I0_45OIGWeMMeta || {},
    component: () => import("/src/pages/auth/reset-password.vue")
  },
  {
    name: "email-oauth-success___fr-FR",
    path: "/email/oauth-success",
    meta: oauth_45successSJsrxqW7g_45INBNmAw63qzwOxu3eO5VWZm8IiVbNxdAUMeta || {},
    component: () => import("/src/pages/email/oauth-success.vue")
  },
  {
    name: "email-oauth-success___en-GB",
    path: "/en-GB/email/oauth-success",
    meta: oauth_45successSJsrxqW7g_45INBNmAw63qzwOxu3eO5VWZm8IiVbNxdAUMeta || {},
    component: () => import("/src/pages/email/oauth-success.vue")
  },
  {
    name: "admin-customers-id___fr-FR",
    path: "/admin/customers/:id()",
    meta: _91id_93AzGiGTtNARe_45iNJ5JSvpg_45vI75jjYaWZCeJf7ON5nHEMeta || {},
    component: () => import("/src/pages/admin/customers/[id].vue")
  },
  {
    name: "admin-customers-id___en-GB",
    path: "/en-GB/admin/customers/:id()",
    meta: _91id_93AzGiGTtNARe_45iNJ5JSvpg_45vI75jjYaWZCeJf7ON5nHEMeta || {},
    component: () => import("/src/pages/admin/customers/[id].vue")
  },
  {
    name: "auth-forgot-password___fr-FR",
    path: "/auth/forgot-password",
    meta: forgot_45passwordFpwAwxBggxx3KkxDmE50wQmdHR5V1iatb2SegeEJCN0Meta || {},
    component: () => import("/src/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-forgot-password___en-GB",
    path: "/en-GB/auth/forgot-password",
    meta: forgot_45passwordFpwAwxBggxx3KkxDmE50wQmdHR5V1iatb2SegeEJCN0Meta || {},
    component: () => import("/src/pages/auth/forgot-password.vue")
  },
  {
    name: "admin-customers___fr-FR",
    path: "/admin/customers",
    meta: indexfYheWFxU_RkH2m7QYfxwjZKjiW6VlBN_45eXdUgr86bZoMeta || {},
    component: () => import("/src/pages/admin/customers/index.vue")
  },
  {
    name: "admin-customers___en-GB",
    path: "/en-GB/admin/customers",
    meta: indexfYheWFxU_RkH2m7QYfxwjZKjiW6VlBN_45eXdUgr86bZoMeta || {},
    component: () => import("/src/pages/admin/customers/index.vue")
  },
  {
    name: "admin-emails-emailId___fr-FR",
    path: "/admin/emails/:emailId()",
    meta: _91emailId_93Pom7i3ZDjDbYSE2rIu5WGe8_Svsmp6mFS4_45GUkPQRw0Meta || {},
    component: () => import("/src/pages/admin/emails/[emailId].vue")
  },
  {
    name: "admin-emails-emailId___en-GB",
    path: "/en-GB/admin/emails/:emailId()",
    meta: _91emailId_93Pom7i3ZDjDbYSE2rIu5WGe8_Svsmp6mFS4_45GUkPQRw0Meta || {},
    component: () => import("/src/pages/admin/emails/[emailId].vue")
  },
  {
    name: "admin-orders-orderId___fr-FR",
    path: "/admin/orders/:orderId()",
    meta: _91orderId_93l0n9GvF64pv3ekD68vL8FgT2DiKRSs0qh1v0msc1pQoMeta || {},
    component: () => import("/src/pages/admin/orders/[orderId].vue")
  },
  {
    name: "admin-orders-orderId___en-GB",
    path: "/en-GB/admin/orders/:orderId()",
    meta: _91orderId_93l0n9GvF64pv3ekD68vL8FgT2DiKRSs0qh1v0msc1pQoMeta || {},
    component: () => import("/src/pages/admin/orders/[orderId].vue")
  },
  {
    name: "customer-requests-requestId___fr-FR",
    path: "/customer/requests/:requestId()",
    meta: _91requestId_937Iay6MZaR3PCgRL0AcGMRpYlME25Z30DBDoI2WiHLzAMeta || {},
    component: () => import("/src/pages/customer/requests/[requestId].vue")
  },
  {
    name: "customer-requests-requestId___en-GB",
    path: "/en-GB/customer/requests/:requestId()",
    meta: _91requestId_937Iay6MZaR3PCgRL0AcGMRpYlME25Z30DBDoI2WiHLzAMeta || {},
    component: () => import("/src/pages/customer/requests/[requestId].vue")
  },
  {
    name: "admin-customers-emails-emailId___fr-FR",
    path: "/admin/customers/emails/:emailId()",
    meta: _91emailId_93tC0vFKa1FkN75qJ9ORqoTyDqh9HhO3KhEb_45nBl6oG1AMeta || {},
    component: () => import("/src/pages/admin/customers/emails/[emailId].vue")
  },
  {
    name: "admin-customers-emails-emailId___en-GB",
    path: "/en-GB/admin/customers/emails/:emailId()",
    meta: _91emailId_93tC0vFKa1FkN75qJ9ORqoTyDqh9HhO3KhEb_45nBl6oG1AMeta || {},
    component: () => import("/src/pages/admin/customers/emails/[emailId].vue")
  }
]